import { createApp } from 'vue';
import Kuma from '@bilibili-firebird/kuma';
import App from './App.vue';

Kuma({
  disableRem: true,
}).then(() => {
  console.log('kuma');
  createApp(App).mount('#app');
}).catch((e) => {
  console.error('kuma error', e);
});
